export const textOverflowMui: Record<string, string> = {
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'unset !important',
  padding: '10px',
};
